module.exports = __webpack_public_path__ + "img/MGH-Roppongi-2-2440x1172.80289049.jpg";